import { Loading } from '@fasstech/middle-design-system';
import SouscriptionCustomerGranteesForm from './SouscriptionCustomerGranteesForm.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import { compose, pathOr } from 'ramda';
import useGetSouscriptionCustomerGranteesQuery from './hooks/useGetSouscriptionCustomerGranteesQuery.js';
import useGetSouscriptionCustomerGranteesCountriesQuery from './hooks/useGetSouscriptionCustomerGranteesCountriesQuery.js';

const SouscriptionCustomerGrantees = ({
  getMiddleText,
  getMiddleBoolean,
  middleFeatures,
  getMiddleNumber,
  professionalSituations,
  socioProfessionalCategories,
  activities,
  regimeObligatoire,
  familySituations
}) => {
  const { getSouscriptionCustomerGrantees, loading: isFetchingGetSouscriptionCustomerGrantees } =
    useGetSouscriptionCustomerGranteesQuery();

  const {
    getSouscriptionCustomerGranteesCountries: getCountries,
    loading: isFetchingGetCountries
  } = useGetSouscriptionCustomerGranteesCountriesQuery({ search: '' });

  if (isFetchingGetSouscriptionCustomerGrantees || isFetchingGetCountries) {
    return <Loading />;
  }

  return (
    <SouscriptionCustomerGranteesForm
      data={getSouscriptionCustomerGrantees}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      middleFeatures={middleFeatures}
      getMiddleNumber={getMiddleNumber}
      jobs={pathOr([], ['jobs'], getSouscriptionCustomerGrantees)}
      professionalSituations={professionalSituations}
      socioProfessionalCategories={socioProfessionalCategories}
      activities={activities}
      regimeObligatoire={regimeObligatoire}
      familySituations={familySituations}
      getCountries={getCountries}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SouscriptionCustomerGrantees);
